export const env = "qa"
export const API_HOST = 'https://tartarus-qa-api.brtws.com'
export const DEBUG_LOGGING = false
export const OKTA_WEB_CLIENT_ID = '0oalfcnr3ulTEIhqG357'
export const OKTA_DEVKIT_CLIENT_ID = '0oa557jtz3gC6nG18357'
export const GA_TRACKING_ID = 'UA-57393998-4'
export const VERSION_1_LINK = 'https://aletheia-qa.brtws.com'
export const KUBEFLOW_URL = 'https://kubeflow.prod.mesa.brtws.com'
export const MACHINE_LOGS_LINK = `https://apps.${env}.mesa.brtws.com/logs`
